module.exports = __webpack_public_path__ + "img/whatsapp.46b3ec02.svg";